<template>
  <div>
    <hshead title="申请城市" bgcolor="#fff"></hshead>
    <div class="side-box">
      <div class="side-left">
        <div class="side-li" @click="activeKey=index" :class="{'act':(index==activeKey)}" v-for="(item, index) in sideList" :key="'side'+index">广州</div>
      </div>
      <div class="side-right">
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in list"
              clickable
              :key="item"
              :title="`复选框 ${item}`"
              @click="toggle(index)"
            >
              <van-checkbox :name="item" ref="checkboxes" slot="right-icon" />
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
    <div class="bottom-btn-box">
      <router-link to class="bottom-btn nobg">取消</router-link>
      <router-link to class="bottom-btn">确定</router-link>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import {
  Sidebar,
  SidebarItem,
  Checkbox,
  CheckboxGroup,
  Cell,
  CellGroup
} from "vant";
export default {
  name: "applicantCity",
  data() {
    return {
      activeKey: 3,
      sideList: ["", "", "", "", "", "", "", "", "", "", ""],
      list: [
        "a",
        "b",
        "c",
        "c",
        "a",
        "b",
        "c",
        "c",
        "a",
        "b",
        "c",
        "c",
        "a",
        "b",
        "c",
        "c",
        "a",
        "b",
        "c",
        "c",
        "a",
        "b",
        "c",
        "c",
        "a",
        "b",
        "c",
        "c",
        "a",
        "b",
        "c",
        "c",
        "a",
        "b",
        "c",
        "c"
      ],
      result: ["a"]
    };
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    }
  },
  components: {
    hshead,
    "van-sidebar": Sidebar,
    "van-sidebar-item": SidebarItem,
    "van-checkbox-group": CheckboxGroup,
    "van-checkbox": Checkbox,
    "van-cell-group": CellGroup,
    "van-cell": Cell
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.side-box {
  display: flex;
  margin-bottom: 1.2rem;
  .side-left {
    width: 2rem;
    background-color: #eef2f5;
    height: 100%;
    .side-li {
      height: 1.2rem;
      background-color: #eef2f5;
      font-size: 0.26rem;
      text-align: center;
      color: #666666;
      line-height: 1.2rem;
      border-bottom: 1px solid #fff;
      &.act {
        border-left: 1px solid #3bb9ff;
        color: #0e9ceb;
        background: #fff;
        margin-right: -1px;
      }
    }
  }
  .side-right {
    flex: 1;
  }
}
.bottom-btn-box {
  width: 7.5rem;
  height: 0.98rem;
  background-color: #ffffff;
  box-shadow: 0rem -0.01rem 0rem 0rem #e5e5e5;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 6;
  display: flex;
  justify-content: flex-end;
  .bottom-btn {
    width: 1.7rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.24rem;
    background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
      linear-gradient(#f2f9fb, #f2f9fb);
    background-blend-mode: normal, normal;
    border-radius: 0.3rem;
    display: block;
    color: #ffffff;
    margin-top: 0.2rem;
    margin-right: 0.3rem;
    &.nobg {
      border: solid 1px #00b8f5;
      background: transparent;
      color: #00b8f5;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/applicantCity.vue